import { render, staticRenderFns } from "./pdp-table.vue?vue&type=template&id=4d3eb29f&scoped=true"
import script from "./pdp-table.vue?vue&type=script&lang=js"
export * from "./pdp-table.vue?vue&type=script&lang=js"
import style0 from "./pdp-table.vue?vue&type=style&index=0&id=4d3eb29f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3eb29f",
  null
  
)

export default component.exports